import React from "react";
import * as CompareEntryStyles from "../../styles/CompareEntry";
import { CommonMonthlyPriceLabelKey } from "../../../../../../common-deprecated/priceUtils";
import { useCompareV2Selector } from "../../../../redux/store";
import type { CarDataType } from "../../../../../../common-deprecated/features/compare/utils/newCarCompareTypes";
import {
    getAemMonthlyRateFormat,
    showAemMonthlyRates,
} from "../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { AemFmComponent } from "../../../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";
import * as Price from "../../../../../../common-deprecated/styles/v2/toyota/components/Price";
import { formatMonthlyFinancePrice } from "../../../../../shared-logic/utils/priceUtils";
import { getDefaultPriceObject } from "../../../../../../common-deprecated/constants";

type PriceSpecType = {
    car: CarDataType;
};

const LeasingSpec = (props: PriceSpecType): JSX.Element | null => {
    const { car } = props;
    const financeInfo = useCompareV2Selector((state) =>
        state.newCarCompare.filteredCarList?.find(
            (filteredCar) => filteredCar.configurationId === car.configuration?.id,
        ),
    );
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);
    const monthlyEnabled = showAemMonthlyRates(commonSettings, AemFmComponent.LeasingFilter, "new");
    if (!monthlyEnabled) return null;

    const monthlyPrice = financeInfo
        ? formatMonthlyFinancePrice(
              { ...getDefaultPriceObject(), monthly: financeInfo.monthlyPayment },
              {
                  downPayment: financeInfo.downpayment?.toString(),
                  term: "",
                  annualInterestRate: "",
                  effectiveInterestRate: "",
              },
              commonSettings,
              getAemMonthlyRateFormat(commonSettings, AemFmComponent.LeasingFilter, "new"),
          )
        : undefined;

    return (
        <CompareEntryStyles.Wrapper>
            {!car.loading && monthlyPrice && (
                <CompareEntryStyles.KeyValue>
                    <CompareEntryStyles.Value heading>
                        {monthlyPrice.labels.map(
                            (label) =>
                                (label.key === CommonMonthlyPriceLabelKey.Price ||
                                    label.key === CommonMonthlyPriceLabelKey.DownPayment) && (
                                    <Price.MonthlyPriceWrapper key={label.key}>
                                        <span dangerouslySetInnerHTML={{ __html: label.value }} />
                                    </Price.MonthlyPriceWrapper>
                                ),
                        )}
                    </CompareEntryStyles.Value>
                    {financeInfo?.legalText && (
                        <CompareEntryStyles.LegalText>
                            <span dangerouslySetInnerHTML={{ __html: financeInfo.legalText }} />
                        </CompareEntryStyles.LegalText>
                    )}
                </CompareEntryStyles.KeyValue>
            )}
        </CompareEntryStyles.Wrapper>
    );
};

export default LeasingSpec;
